<div class="card">
    <div class="skeleton" [ngStyle]="{'width': width, 'height': height, 'margin-bottom': marginBottom}"></div>
</div>